import React,{useState,useEffect} from "react";
import CustomHeading from '../../../constants/CustomHeading'
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';
import CustomInput from '../../../constants/CustomInput';
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomTextArea from '../../../constants/CustomTextArea';
import CustomButton from "../../../constants/CustomButton";
import CustomRichTextField from "../../../constants/CustomRichTextField";
import CustomTableWithAll from '../../../constants/CustomTableWithAll';
import {connect} from 'react-redux';
import {setConsultingTestingProjectData,getConsultingTestingProjectData} from '../../../redux/actions/dataAction';
import CustomLine from "../../../constants/CustomLine";

const validationSchema = Yup.object().shape({
    project_title: Yup.string()
    .required('Required'),
    commencement_year: Yup.date()
    .required('Required'),
    status: Yup.string()
    .required('Required'),
    your_role: Yup.string()
    .required('Required'),
});

const ConsultancyTestingProjects=(props)=>{
    const [isLoading,setIsLoading]=useState(false);
    useEffect(()=>{
        props.getConsultingTestingProjectData();
    },[isLoading])
    const columns = [ 
        {title:'Project title',field:'project_title'},
        {title:'Project Code',field:'project_code' },
        {title:'Client',field:'client'},
        {title:'Your Role',field:'your_role'},
        {title:'Commencement year',field:'commencement_year'},
        {title:'Completion year',field:'completion_year'},
        {title:'Status',field:'status'},

      ]
    return(
        <div className="customContainer">
             <CustomHeading title="Consultancy/Testing Project"/>
             <CustomTableWithAll data={props?.consulting_projects?.data}  columns={columns} api="/api/Consulting-Testing-Project/"  title={'All Consulting/Testing Projects'} />
        <CustomLine/>
            <Formik
            initialValues={{
                project_title: "",
                project_code: "",
                abstract: "",
                client: "",
                revenue_earned: 0,
                commencement_year: "",
                completion_year: "",
                status: "",
                your_role: "",
                co_consultants: "",
                created_by: "admin@test.com"
            }}
            validationSchema={validationSchema}
            onSubmit={values=>{
            console.log(values);
            props.setConsultingTestingProjectData(values);
            setIsLoading(true)
            }}
            >
            {({ errors, touched,handleChange,handleSubmit,setFieldValue,values }) => (
            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
              <div className="row">
                <div className="col-md-6">
                <CustomTextArea
                    type={'text'}
                    label={'Project Title :'}
                    placeholder={'Enter Project Title'}
                    onChange={handleChange('project_title')}
                    rows={2}
                    errorText={
                        errors.project_title && touched.project_title?errors.project_title:null
                    }
                    />
                </div>
                <div className="col-md-6">
                <CustomInput
                    type={'date'}
                    placeholder={'Select Year'}
                    label={'Commencement Year :'}
                    onChange={handleChange('commencement_year')}
                    errorText={
                            errors.commencement_year && touched.commencement_year?errors.commencement_year:null
                    }
                    />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                <CustomInput
                    type={'text'}
                    placeholder={'Enter Project Code'}
                    label={'Project Code :'}
                    onChange={handleChange('project_code')}
                    />
                </div>
                <div className="col-md-6">
                <CustomInput
                    type={'date'}
                    placeholder={'Select Year'}
                    label={'Completion Year :'}
                    onChange={handleChange('completion_year')}
                    />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                <CustomTextArea
                    type={'text'}
                    label={'Client :'}
                    placeholder={'Enter Client\'s Name'}
                    onChange={handleChange('client')}
                    rows={2}
                    errorText={
                        errors.project_title && touched.project_title?errors.project_title:null
                    }
                    />	
                </div>
                <div className="col-md-6">
                <CustomDropdown 
                    label="Status : "
                    data={[{value:"On Going"},{value:"Completed"},{value:"Submitted"}]}
                    onChange={handleChange('status')}
                    errorText={
                        errors.status && touched.status ?errors.status :null
                    }
                    />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                <CustomInput
                    type={'number'}
                    placeholder={'Enter Amount'}
                    label={'Revenue Earned (in Rs.) :'}
                    onChange={handleChange('revenue_earned')}
                    />
                </div>
                <div className="col-md-6">
                <CustomDropdown 
                    label="Your Role : "
                    data={[{value:"Consultant"},{value:"Co-Consultant"},{value:"Others"}]}
                    onChange={handleChange('your_role')}
                    errorText={
                        errors.your_role && touched.your_role ?errors.your_role :null
                    }
                    />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                <CustomTextArea
                    type={'text'}
                    label={'Co-Consultant(s) :'}
                    placeholder={'Enter Consultant\'s Name'}
                    onChange={handleChange('co_consultants')}
                    rows={2}
                    />	
                </div>
                <div className="col-md-6">
                    {/* {values.your_role==='Others'?
                    <>
                    <CustomInput
                    type={'text'}
                    placeholder={'Specify User Role'}
                    label={'Specify :'}
                    onChange={handleChange('your_role')}
                    errorText={
                        errors.your_role && touched.your_role ?errors.your_role :null
                    }
                    />
                    
                    </>:null
                    } */}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                <CustomRichTextField label={'Abstract'} onChange={handleChange('abstract')}/>
                </div>
              </div>
              <CustomButton type="submit" label="Save" />
              
            </Form>
          )}
            </Formik> 
        </div>
    );
};

const mapActionWithProps = {
    getConsultingTestingProjectData,
    setConsultingTestingProjectData,
  }
  
  const mapStateWithProps = (state)=>(
    {
        consulting_projects:state.data.consulting_projects
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(ConsultancyTestingProjects);